import {size} from "../../../../lib/size";

type Props = {
    heroImage?: {
        url?: string;
        title?: string;
        caption?: string;
    };
};

export const HeroImage = ({ heroImage }: Props) => {
    if (!heroImage?.url) return null;

    return (
        <div
            className="mt-1 mb-4 mx-auto flex flex-col min-h-[350px]"
            style={{ maxWidth: size.tailwindMd }}
        >
            <img
                src={heroImage.url}
                alt={heroImage.title ?? ""}
                loading="lazy"
                decoding="async"
                className="w-full h-auto"
            />
            {heroImage.caption && (
                <p className="mt-2 text-sm text-gray-500 italic">
                    {heroImage.caption}
                </p>
            )}
        </div>
    );
};
